// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
   CompartirPlanes.css — imagen de planes para WhatsApp + su modal
   ----------------------------------------------------------------------------
   EXCEPCION a "todo color sale de var(--sn-*)" en .cp-hoja: es el PNG que se
   comparte, no interfaz. Tiene que salir igual se genere en tema claro u
   oscuro, así que usa los colores de marca del logo (#a41619, #77070a,
   #202930) y el grafito de la web sisnetel.com. #25D366 es el verde oficial
   de WhatsApp (marca externa). El modal sí usa los tokens del tema.
   ============================================================================ */

/* ── La hoja que se convierte en imagen (fuera de la pantalla) ────────────── */

.cp-hoja {
  position: fixed;
  top: 0;
  left: -10000px;
  width: 360px;
  box-sizing: border-box;
  padding: 22px 20px 18px;
  background-color: #12171b;
  background-image: radial-gradient(130% 38% at 100% 0%, rgba(164, 22, 25, 0.5) 0%, rgba(164, 22, 25, 0) 70%);
  color: #fff;
  line-height: 1.25;
  text-align: left;
}

.cp-cabecera {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* El PNG del logo trae margen transparente: se compensa para alinearlo */
.cp-logo {
  height: 58px;
  width: auto;
  margin: -6px 0 -6px -10px;
}

.cp-pastilla {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 999px;
  padding: 4px 10px;
}

.cp-kicker {
  margin-top: 14px;
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #ff8a8d;
}

.cp-titulo {
  margin-top: 6px;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.02em;
}

.cp-titulo span {
  color: #ff6a6e;
}

.cp-sub {
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.4;
  color: #b6c0c8;
}

.cp-planes {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cp-plan {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 14px;
  background-color: #1a2126;
  border: 1px solid #323c44;
}

.cp-plan--destacado {
  background-color: #a41619;
  background-image: linear-gradient(135deg, #b71c1c 0%, #77070a 100%);
  border-color: #d32f2f;
}

.cp-plan-info {
  min-width: 0;
}

.cp-plan-fila {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cp-plan-nombre {
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.01em;
}

.cp-plan-badge {
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  padding: 3px 8px;
  white-space: nowrap;
}

.cp-plan-frase {
  margin-top: 3px;
  font-size: 11px;
  color: #b6c0c8;
}

.cp-plan--destacado .cp-plan-frase {
  color: rgba(255, 255, 255, 0.88);
}

.cp-plan-dispositivos {
  display: inline-block;
  margin-top: 6px;
  font-size: 10px;
  font-weight: 700;
  color: #e9edf0;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  padding: 2px 8px;
}

.cp-plan-precio {
  flex-shrink: 0;
  text-align: right;
}

.cp-plan-precio strong {
  display: block;
  font-size: 30px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.02em;
}

.cp-plan-precio span {
  display: block;
  margin-top: 3px;
  font-size: 10px;
  color: #b6c0c8;
}

.cp-plan--destacado .cp-plan-precio span {
  color: rgba(255, 255, 255, 0.85);
}

.cp-incluye {
  margin-top: 16px;
}

.cp-incluye-titulo {
  margin-bottom: 8px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #98a3ac;
}

.cp-incluye-lista {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 12px;
}

.cp-incluye-item {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  color: #e9edf0;
}

.cp-punto {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ff6a6e;
}

.cp-pie {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #323c44;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.cp-contacto {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cp-whatsapp {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #25d366;
  color: #fff;
  font-size: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cp-contacto-etiqueta {
  font-size: 10px;
  color: #98a3ac;
}

.cp-contacto-numero {
  font-size: 15px;
  font-weight: 800;
}

.cp-web {
  text-align: right;
}

.cp-web strong {
  display: block;
  font-size: 12px;
  font-weight: 800;
}

.cp-web span {
  font-size: 10px;
  color: #98a3ac;
}

/* ── Modal (interfaz: tokens del tema) ────────────────────────────────────── */

/* .modal-body.cp-modal: el CSS de Bootstrap se carga después y su .modal-body
   pisaría el padding con la misma especificidad. */
.modal-body.cp-modal {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: var(--sn-superficie);
}

.cp-modal-titulo {
  font-size: 16px;
  font-weight: 800;
  color: var(--sn-texto);
}

.cp-modal-sub {
  margin-top: 2px;
  font-size: 12px;
  color: var(--sn-texto-3);
}

.cp-vista {
  flex: 1 1;
  min-height: 240px;
  max-height: 64vh;
  overflow-y: auto;
  display: flex;
  background: var(--sn-superficie-2);
  border: 1px solid var(--sn-borde);
  border-radius: 12px;
}

/* En el teléfono el modal es de pantalla completa: la imagen usa todo el alto,
   y el título y los botones se apartan de la barra de estado y de la barra de
   navegación del sistema (la app va de borde a borde con targetSdk 36). */
@media (max-width: 575.98px) {
  .modal-body.cp-modal {
    padding-top: calc(16px + env(safe-area-inset-top, 0px));
    padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
  }

  .cp-vista {
    max-height: none;
  }
}

.cp-vista img {
  display: block;
  width: 100%;
  height: auto;
  align-self: flex-start;
  border-radius: 11px;
}

.cp-vista-estado {
  margin: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
  font-size: 13px;
  color: var(--sn-texto-3);
}

.cp-acciones {
  display: flex;
  gap: 8px;
}

.cp-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid transparent;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
}

.cp-btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.cp-btn--principal {
  flex: 1 1;
  background: var(--sn-accion);
  color: var(--sn-accion-texto);
}

.cp-btn--principal:active:not(:disabled) {
  background: var(--sn-accion-hover);
}

.cp-btn--secundario {
  background: transparent;
  border-color: var(--sn-borde-fuerte);
  color: var(--sn-texto-2);
}
`, "",{"version":3,"sources":["webpack://./src/components/CompartirPlanes.css"],"names":[],"mappings":"AAAA;;;;;;;;iFAQiF;;AAEjF,gFAAgF;;AAEhF;EACE,eAAe;EACf,MAAM;EACN,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2GAA2G;EAC3G,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,yEAAyE;AACzE;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;EACpC,2CAA2C;EAC3C,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;EACpC,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;EAC3C,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,gFAAgF;;AAEhF;mDACmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;;0EAE0E;AAC1E;EACE;IACE,uDAAuD;IACvD,6DAA6D;EAC/D;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,wBAAwB;AAC1B","sourcesContent":["/* ============================================================================\n   CompartirPlanes.css — imagen de planes para WhatsApp + su modal\n   ----------------------------------------------------------------------------\n   EXCEPCION a \"todo color sale de var(--sn-*)\" en .cp-hoja: es el PNG que se\n   comparte, no interfaz. Tiene que salir igual se genere en tema claro u\n   oscuro, así que usa los colores de marca del logo (#a41619, #77070a,\n   #202930) y el grafito de la web sisnetel.com. #25D366 es el verde oficial\n   de WhatsApp (marca externa). El modal sí usa los tokens del tema.\n   ============================================================================ */\n\n/* ── La hoja que se convierte en imagen (fuera de la pantalla) ────────────── */\n\n.cp-hoja {\n  position: fixed;\n  top: 0;\n  left: -10000px;\n  width: 360px;\n  box-sizing: border-box;\n  padding: 22px 20px 18px;\n  background-color: #12171b;\n  background-image: radial-gradient(130% 38% at 100% 0%, rgba(164, 22, 25, 0.5) 0%, rgba(164, 22, 25, 0) 70%);\n  color: #fff;\n  line-height: 1.25;\n  text-align: left;\n}\n\n.cp-cabecera {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* El PNG del logo trae margen transparente: se compensa para alinearlo */\n.cp-logo {\n  height: 58px;\n  width: auto;\n  margin: -6px 0 -6px -10px;\n}\n\n.cp-pastilla {\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  border-radius: 999px;\n  padding: 4px 10px;\n}\n\n.cp-kicker {\n  margin-top: 14px;\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #ff8a8d;\n}\n\n.cp-titulo {\n  margin-top: 6px;\n  font-size: 30px;\n  font-weight: 800;\n  line-height: 1.05;\n  letter-spacing: -0.02em;\n}\n\n.cp-titulo span {\n  color: #ff6a6e;\n}\n\n.cp-sub {\n  margin-top: 8px;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #b6c0c8;\n}\n\n.cp-planes {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.cp-plan {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: 14px;\n  background-color: #1a2126;\n  border: 1px solid #323c44;\n}\n\n.cp-plan--destacado {\n  background-color: #a41619;\n  background-image: linear-gradient(135deg, #b71c1c 0%, #77070a 100%);\n  border-color: #d32f2f;\n}\n\n.cp-plan-info {\n  min-width: 0;\n}\n\n.cp-plan-fila {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.cp-plan-nombre {\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n}\n\n.cp-plan-badge {\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 999px;\n  padding: 3px 8px;\n  white-space: nowrap;\n}\n\n.cp-plan-frase {\n  margin-top: 3px;\n  font-size: 11px;\n  color: #b6c0c8;\n}\n\n.cp-plan--destacado .cp-plan-frase {\n  color: rgba(255, 255, 255, 0.88);\n}\n\n.cp-plan-dispositivos {\n  display: inline-block;\n  margin-top: 6px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #e9edf0;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 999px;\n  padding: 2px 8px;\n}\n\n.cp-plan-precio {\n  flex-shrink: 0;\n  text-align: right;\n}\n\n.cp-plan-precio strong {\n  display: block;\n  font-size: 30px;\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: -0.02em;\n}\n\n.cp-plan-precio span {\n  display: block;\n  margin-top: 3px;\n  font-size: 10px;\n  color: #b6c0c8;\n}\n\n.cp-plan--destacado .cp-plan-precio span {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.cp-incluye {\n  margin-top: 16px;\n}\n\n.cp-incluye-titulo {\n  margin-bottom: 8px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #98a3ac;\n}\n\n.cp-incluye-lista {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 6px 12px;\n}\n\n.cp-incluye-item {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 11px;\n  color: #e9edf0;\n}\n\n.cp-punto {\n  flex-shrink: 0;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #ff6a6e;\n}\n\n.cp-pie {\n  margin-top: 16px;\n  padding-top: 14px;\n  border-top: 1px solid #323c44;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.cp-contacto {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.cp-whatsapp {\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: #25d366;\n  color: #fff;\n  font-size: 19px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cp-contacto-etiqueta {\n  font-size: 10px;\n  color: #98a3ac;\n}\n\n.cp-contacto-numero {\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.cp-web {\n  text-align: right;\n}\n\n.cp-web strong {\n  display: block;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.cp-web span {\n  font-size: 10px;\n  color: #98a3ac;\n}\n\n/* ── Modal (interfaz: tokens del tema) ────────────────────────────────────── */\n\n/* .modal-body.cp-modal: el CSS de Bootstrap se carga después y su .modal-body\n   pisaría el padding con la misma especificidad. */\n.modal-body.cp-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  background: var(--sn-superficie);\n}\n\n.cp-modal-titulo {\n  font-size: 16px;\n  font-weight: 800;\n  color: var(--sn-texto);\n}\n\n.cp-modal-sub {\n  margin-top: 2px;\n  font-size: 12px;\n  color: var(--sn-texto-3);\n}\n\n.cp-vista {\n  flex: 1;\n  min-height: 240px;\n  max-height: 64vh;\n  overflow-y: auto;\n  display: flex;\n  background: var(--sn-superficie-2);\n  border: 1px solid var(--sn-borde);\n  border-radius: 12px;\n}\n\n/* En el teléfono el modal es de pantalla completa: la imagen usa todo el alto,\n   y el título y los botones se apartan de la barra de estado y de la barra de\n   navegación del sistema (la app va de borde a borde con targetSdk 36). */\n@media (max-width: 575.98px) {\n  .modal-body.cp-modal {\n    padding-top: calc(16px + env(safe-area-inset-top, 0px));\n    padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));\n  }\n\n  .cp-vista {\n    max-height: none;\n  }\n}\n\n.cp-vista img {\n  display: block;\n  width: 100%;\n  height: auto;\n  align-self: flex-start;\n  border-radius: 11px;\n}\n\n.cp-vista-estado {\n  margin: auto;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  text-align: center;\n  font-size: 13px;\n  color: var(--sn-texto-3);\n}\n\n.cp-acciones {\n  display: flex;\n  gap: 8px;\n}\n\n.cp-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: 1px solid transparent;\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.cp-btn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.cp-btn--principal {\n  flex: 1;\n  background: var(--sn-accion);\n  color: var(--sn-accion-texto);\n}\n\n.cp-btn--principal:active:not(:disabled) {\n  background: var(--sn-accion-hover);\n}\n\n.cp-btn--secundario {\n  background: transparent;\n  border-color: var(--sn-borde-fuerte);\n  color: var(--sn-texto-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
